import { Box, styled } from '@mui/material';

export const MarkedChange = styled(Box)(({ theme }) => ({
  backgroundColor: theme.vars.palette.semantic.tint.yellow.medium,
  color: theme.vars.palette.semantic.tint.yellow.text,
  padding: 6,
  display: 'flex',
  borderRadius: 10,
}));
